<template>
  <header>
    <div class="logo">
      <img v-if="config.logo_base64" class="partner" :style="config.logo_style" :src="config.logo_base64" :alt="config.org_label || 'Partner organization'" />
      <img class="ff" src="../assets/images/logo.svg" alt="Flightfox" />
    </div>
  </header>
</template>

<script setup>
defineProps({
  config: {
    type: Object,
    required: true,
  },
});
</script>
